import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { removeVehicleFromGroup } from '../../services/GroupsService';
import { Group, AddVehicleToGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, AddVehicleToGroupRequest>;

function useDeleteVehicleFromGroup(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(removeVehicleFromGroup, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups', 'vehicle', 'vehicles'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteVehicleFromGroup;
